module.exports = __webpack_public_path__ + "media/images/bank-logo-c737480b35bda3dc3b972fcbded1be65.png";